import { render, staticRenderFns } from "./assignPermission.vue?vue&type=template&id=e3c9d87c&scoped=true"
import script from "./assignPermission.vue?vue&type=script&lang=js"
export * from "./assignPermission.vue?vue&type=script&lang=js"
import style0 from "./assignPermission.vue?vue&type=style&index=0&id=e3c9d87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c9d87c",
  null
  
)

export default component.exports